import {useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import moment from 'moment'
import useGanttResourceReducer, {
  ActionTypes,
} from '../../../state/reservation/gantt-resources/reducer'
import {
  searchGroupObjects,
  searchGanttObjects,
  resetResources,
  removeEventViaID,
} from '../../../state/reservation/gantt-resources/actions'
import useReservationGanttContext from '../../../context/ReservationGantt/ReservationGantt'
import GlobalEvents from '../../../utils/EventSystem'
const useGanttItemLoader = () => {
  const {viewData, filters, query, columnHeaders} = useReservationGanttContext()
  const [resources, dispatch] = useGanttResourceReducer()
  const callDelay = useRef(null)
  const [additionalFilters, setAdditionalFilters] = useState({})
  const [limit, setLimit] = useState(50)
  const refTryCallApi = useRef(null)
  const entityKey = Object.keys(additionalFilters)[0]
  const entityKeyId = additionalFilters[entityKey]
  // this will update regardless of state without needed to be put in dependencies
  // copy
  const resourceParamsCache = useRef({
    field_filters: null,
    multiple_filter_views: {},
    includes: ['action_objects', 'entity_actions'],
    start_date: null,
    end_date: null,
    entity_action_ids: [],
    offset: 0,
    limit: limit,
  })
  // last date filter cache, for optimization
  const dateFilterCache = useRef({
    start_date: null,
    end_date: null,
  })
  refTryCallApi.current = (params, {events_only = false}) => {
    if (
      !!!params.entity_id ||
      params.start_date === null ||
      params.end_date === null ||
      params.field_filters === null
    )
      return
    if (callDelay.current) {
      clearTimeout(callDelay.current)
      callDelay.current = null
    }
    callDelay.current = setTimeout(
      () => {
        dateFilterCache.current = {
          start_date: params.start_date,
          end_date: params.end_date,
        }
        // params['is_reservation'] = true
        searchGanttObjects(dispatch, params.entity_id, _.cloneDeep(viewData), params, events_only)
        // searchGroupObjects(dispatch, params.entity_id, _.cloneDeep(viewData), params, events_only)
      },
      250 // 250ms
    )
  }
  // load but no refresh
  useEffect(() => {
    if (columnHeaders.primary.length === 0) return
    let startSec = columnHeaders.primary[0].sec
    let endSec = columnHeaders.primary[columnHeaders.primary.length - 1].endSec
    resourceParamsCache.current = {
      ...resourceParamsCache.current,
      start_date: moment(startSec).format('YYYY-MM-DD HH:mm:ss'),
      end_date: moment(endSec).format('YYYY-MM-DD HH:mm:ss'),
      limit: limit,
    }
    const {start_date, end_date} = dateFilterCache.current
    let start_end = {}
    if (!!start_date && !!end_date) {
      const _start = moment(start_date).valueOf()
      const _end = moment(end_date).valueOf()
      if (_end > startSec && _end < endSec && _start < startSec) {
        start_end = {...start_end, start_date: moment(_end).format('YYYY-MM-DD HH:mm:ss')}
      }
      if (_start > startSec && _start < endSec && _end > endSec) {
        start_end = {...start_end, end_date: moment(_start).format('YYYY-MM-DD HH:mm:ss')}
      }
    }
    refTryCallApi.current(
      {
        ...resourceParamsCache.current,
        offset: 0,
        limit: resourceParamsCache.current.limit + resourceParamsCache.current.offset,
        ...start_end,
      },
      {events_only: true}
    )
  }, [columnHeaders, limit])
  // load and refresh
  useEffect(() => {
    const {selectedView, selectedFilteredViews, is_shareable_view} = viewData
    let VDisplayFields
    if (!!selectedView?.group_view?.entity_id) {
      let vfilters = {}
      if (!is_shareable_view && !!selectedFilteredViews) {
        vfilters = selectedFilteredViews?.reduce((ret, sfv) => {
          ret[sfv.name] = sfv.filters?.reduce((retf, f) => {
            retf[f.key] = f.values?.map(v => v.id)
            return retf
          }, {})
          return ret
        }, {})
      }
      let _filters = {}
      if (filters.length) {
        let _gfilters = {}
        filters.forEach(f => {
          _gfilters[f.key] = f.value
        })
        _filters = {..._gfilters, ...additionalFilters}
      }
      selectedFilteredViews &&
        selectedFilteredViews.forEach((val, id) => {
          let data
          if (!_.isEmpty(val.display_fields)) {
            data = val.display_fields
          }
          VDisplayFields = data
        })
      const displayFiedld = !_.isEmpty(selectedFilteredViews)
        ? VDisplayFields
        : selectedView?.group_view?.display_fields
      if (is_shareable_view) {
        const svfilters =
          selectedView?.group_view?.filters?.reduce((r, f) => {
            r[f.key] = f.values.map(ff => ff.id)
            return r
          }, {}) || {}
        _filters = {..._filters, ...svfilters}
      }
      resourceParamsCache.current = {
        ...resourceParamsCache.current,
        field_filters: _filters,
        multiple_filter_views: vfilters,
        entity_action_ids:
          selectedFilteredViews?.length > 0
            ? selectedFilteredViews[selectedFilteredViews?.length - 1]?.actions
                ?.filter(f => f.active)
                ?.map(v => v.action_id)
            : selectedView.group_view.actions.filter(f => f.active).map(v => v.action_id),
        offset: 0,
        entity_id: selectedView?.group_view?.entity_id,
        search: query ? query : '',
        display_fields: displayFiedld || [],
        applied_filters: !_.isEmpty(additionalFilters.applied_filters)
          ? additionalFilters.applied_filters
          : {[entityKey]: entityKeyId},
      }
      // clear cache first
      dateFilterCache.current = {
        start_date: null,
        end_date: null,
      }
      dispatch({type: ActionTypes.SET_VIEW, payload: {viewData, reset: true}})
      refTryCallApi.current(resourceParamsCache.current, {events_only: false})
    } else {
      dispatch({type: ActionTypes.RESET})
    }
  }, [viewData, filters, query, dispatch, additionalFilters, entityKeyId, entityKey])
  const loadItems = params => {
    resourceParamsCache.current = {
      ...resourceParamsCache.current,
      ...params,
    }
    // try call
    refTryCallApi.current(resourceParamsCache.current, {events_only: false})
  }
  useEffect(() => {
    const f = data => {
      removeEventViaID(dispatch, data.entity_object.id, data.id)
    }
    const f_new = data => {
      refTryCallApi.current(resourceParamsCache.current, {events_only: false})
    }
    GlobalEvents.on('reservation:cancel', f)
    GlobalEvents.on('reservation:delete', f)
    GlobalEvents.on('reservation:new', f_new)
    GlobalEvents.on('reservation:next-step', f_new)
    return () => {
      GlobalEvents.off('reservation:cancel', f)
      GlobalEvents.off('reservation:delete', f)
      GlobalEvents.off('reservation:new', f_new)
      GlobalEvents.off('reservation:next-step', f_new)
    }
  }, [dispatch])
  return {
    setAdditionalFilters,
    resources,
    loadItems,
    setLimit,
  }
}
export default useGanttItemLoader
// aux
const getStartEndDate = columnHeaders => {
  if (columnHeaders.primary.length === 0) return {}
  const startSec = columnHeaders.primary[0].sec
  const endSec = columnHeaders.primary[columnHeaders.primary.length - 1].endSec
  return {
    start_date: moment(startSec).format('YYYY-MM-DD HH:mm:ss'),
    end_date: moment(endSec).format('YYYY-MM-DD HH:mm:ss'),
  }
}
